import styled from "styled-components";

export const Wrap = styled.div`
  display: none;
  position: absolute;
  width: 100%;
  background: #fff;
  margin: 0 -24px;
  min-height: 110px;
  max-height: 420px;
  overflow-y: auto;
  box-shadow: inset 0 4px 4px -2px rgba(0, 0, 0, 0.08);
  transform: translate(0, 65px);
  padding-bottom: 140px;

  &.active {
    display: block;
    border-radius: 0 0 3px 3px;
  }

  &.toggled {
    top: 33px;
    padding-bottom: 38px;
  }

  @media (min-width: 990px) {
    position: static;
    display: block;
    width: auto;
    box-shadow: none;
    transform: translate(0px, 0);
    padding-bottom: 0;
  }
`;

export const Breakfasts = styled.div`
  padding: 11px 22px;
  background: rgba(255, 139, 0, 0.05);
`;

export const Entrees = styled.div`
  padding: 11px 22px;
`;

export const Title = styled.h4`
  position: relative;
  margin: 0;
  padding: 4px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #e6e6e6;
  font-size: 18px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.34px;

  @media (min-width: 990px) {
    font-size: 16px;
  }
`;

export const BreakfastsTitle = styled(Title)`
  color: var(--color-primary);
`;

export const EntreesTitle = styled(Title)`
  color: var(--color-secondary);
`;

export const ClearAll = styled.button`
  position: absolute;
  top: 2px;
  right: 0;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  font-size: 16px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.3px;
  color: var(--color-primary);
  text-decoration: none;
  cursor: pointer;
  outline: none;
  box-shadow: none;

  &:focus,
  &:hover,
  &:active {
    outline: none;
    box-shadow: none;
  }
`;

export const ItemWrap = styled.div``;

export const EmptyBreakfast = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 90px;
  margin-top: 10px;
  border: 1px dashed #e6e6e6;
  border-radius: 4px;

  svg {
    opacity: 0.3;
  }
`;

export const EmptyEntree = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 90px;
  margin-top: 10px;
  border: 1px dashed #e6e6e6;
  border-radius: 4px;

  svg {
    opacity: 0.3;
  }
`;
